import React, { FC } from 'react'

type Props = {
  radius: number
  className?: string
}

const Bullet: FC<Props> = ({ radius, className }) => {
  if (radius <= 0) {
    radius = 0
  }

  const diameter = radius * 2
  const width = diameter
  const height = diameter

  return <div style={{ width, height }} className={`${className} br-100 `} />
}

export default Bullet
